import './cs.scss';
import React, {useMemo, useRef, useState} from 'react';
import TablePage from "../../pages/tablePage/TablePage";
import CsMacroEditModal from "./CsMacroEditModal";

const MacroManager = () => {
    const [rowData, setRowData] = useState({});

    const refreshRef = useRef(null);

    const columns = useMemo(() => ([
        {
            title: 'index',
            dataIndex: 'index',
            key: 'index',
            width: 180,
        },
        {
            title: '라벨',
            dataIndex: 'label',
            search: true,
        },
        {
            title: '한국어 타이틀',
            dataIndex: 'value',
            render: ((_, {value}) => value.ko.title),
        },
    ]), []);

    const props = {
        columns,
        rowData,
        setRowData,
        refreshRef,
        url: '/css/macro',
        modal: CsMacroEditModal,
        buttonText: '신규 템플릿 추가',
    }

    return (
        <TablePage {...props}/>
    );
};

export default MacroManager;